import React from 'react';
import { Drawer } from '@mui/material';
import { useTaskQueueStore } from '../../stores/taskQueueStore';
import { TaskQueueContent } from './TaskQueueContent';

const DRAWER_WIDTH = '66vw';

export const TaskQueueDrawer: React.FC = () => {
  const { isOpen, close } = useTaskQueueStore();

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={close}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: '66vw' },
          display: 'flex',
          flexDirection: 'column',
          top: 64,
          height: 'calc(100% - 64px)',
        },
      }}
    >
      <TaskQueueContent variant="drawer" onClose={close} />
    </Drawer>
  );
};
